import React, {Component} from 'react';
import { AppViews } from 'resources/enums';
import SubscriptionButtonScreen from 'screens/subscriptionbutton/index';
import ErrorScreen from 'screens/error/index';

export default class Main extends Component {

    render() {
        let view = null;

        switch(this.props.app.appView) {
            case AppViews.MAIN:
                view = (<SubscriptionButtonScreen />);
                break;
            case AppViews.ERROR:
                view = (<ErrorScreen />);
            default:
                break;
        }

        return (
            <>   
                {this.props.app.appView == AppViews.MAIN 
                    ? (
                        <>
                            {view}
                        </>
                    )
                    : (
                        <div className="contenidoGestion">
                            {view}
                        </div>  
                    )
                }             
            </>
        );
    }
}